/**
 * `window.matchMedia`, for environments that may not have it.
 *
 * Three of them reach this code and none is exotic:
 *
 * * **jsdom**, which implements no CSS object model and so ships no
 *   `matchMedia`. Calling it unguarded means importing the package's barrel
 *   throws before a single test runs — the theme store reads the colour-scheme
 *   preference at module scope — and every consumer becomes untestable for a
 *   reason that has nothing to do with what they were testing.
 * * **server-side rendering**, where there is no `window` at all.
 * * **an embedded webview**. `matchMedia` is old and broadly supported, but a
 *   product installed on a customer's own machines is opened by whatever the
 *   customer's estate happens to run.
 *
 * Returns `null` rather than a stub so a caller has to decide what "unknown"
 * means for it. Every caller here decides the same thing — light, no listener —
 * and says so at the call site.
 */
export function mediaQuery(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(query);
}
